<div class="log-out-warning-content-container">
  <div class="mat-headline-4 log-out-warning-text-container">
    <span class="log-out-warning-countdown-text-header"
      >Your session has been idle for more than
      {{ timeoutMinutes }} minutes.</span
    >

    <span class="log-out-warning-countdown-text"
      >You will be logged out of all browser sessions in
      <b>{{ countdown }}</b> seconds</span
    >
  </div>
  <div class="log-out-warning-button">
    <app-action-button
      kind="filled"
      color="primary"
      size="extra-wide"
      (onClick)="close('cancel')"
      >Yes, log out</app-action-button
    >
  </div>
  <div class="log-out-warning-button">
    <app-action-button
      kind="outline"
      color="primary"
      size="extra-wide"
      (onClick)="close('continue')"
      >No, stay logged in</app-action-button
    >
  </div>
</div>
